import React from "react";

export interface TOCItem {
  id: string;
  title: string;
}

interface DocsTOCProps {
  items: TOCItem[];
}

const DocsTOC = ({ items }: DocsTOCProps) => {
  return (
    <div className="flex flex-col gap-5">
      <h5 className="text-[13px] font-bold tracking-tight text-black uppercase">
        On this page
      </h5>
      <nav className="flex flex-col gap-3">
        {items.map((item, idx) => (
          <a
            key={idx}
            href={`#${item.id}`}
            className="text-[13px] leading-snug text-slate-500 hover:text-black transition-colors"
          >
            {item.title}
          </a>
        ))}
      </nav>
    </div>
  );
};

export default DocsTOC;
